import { reveal } from "@components/animations";
import { Breadcrumbs } from "@components/shared";
import { certificateData } from "@demo-data/certification";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const VERIFY_URL =
  "https://learnwithsumit.com/certificates/verify/LWSCTXN-SNT7PO6I";

export default function CertificationPage() {
  const {
    courseCertificate,
    courseReport,
    feedback,
    platform,
    recommendation,
    tag,
    title,
  } = certificateData || {};

  const documents = [
    { label: "Course Certificate", src: courseCertificate },
    { label: "Course Report", src: courseReport },
    { label: "Recommendation Letter", src: recommendation },
  ];

  return (
    <Container maxWidth="lg">
      <Stack gap={4}>
        <Breadcrumbs title="certification" description={"My certifications"} />

        {/* Course summary */}
        <Box {...reveal("up", 0, "anim-panel")}>
          <Typography
            color="text.primary"
            fontSize={{ xs: 16, sm: 18 }}
            fontWeight={600}
          >
            {title} by{" "}
            <a
              className="anim-link"
              href={VERIFY_URL}
              target="_blank"
              rel="noreferrer"
              title="Click to verify the certificate"
            >
              {platform}
            </a>
          </Typography>

          <Divider sx={{ my: 2.5 }} />

          <Typography className="anim-panel__label">
            Topics i learned from this course
          </Typography>
          <Box className="anim-tags">
            {tag?.map((item) => (
              <span className="anim-tag" key={item}>
                {item}
              </span>
            ))}
          </Box>

          <Divider sx={{ my: 2.5 }} />

          <Typography className="anim-panel__label">
            Course instructor feedback
          </Typography>
          <Typography
            color="text.secondary"
            fontSize={{ xs: 13, sm: 15 }}
            lineHeight={1.7}
          >
            {feedback}
          </Typography>
        </Box>

        {/* Documents */}
        <Box className="anim-doc-grid">
          {documents.map((document, index) => (
            <Box key={document.label} {...reveal("up", index * 80)}>
              <div className="anim-doc">
                <div className="anim-doc__media">
                  <LazyLoadImage
                    alt={document.label}
                    effect="blur"
                    src={document.src}
                    width={"100%"}
                    height={"100%"}
                  />
                </div>
                <div className="anim-doc__caption">{document.label}</div>
              </div>
            </Box>
          ))}
        </Box>
      </Stack>
    </Container>
  );
}
